import { render, staticRenderFns } from "./MapaSetorizacao.vue?vue&type=template&id=35836967&"
import script from "./MapaSetorizacao.vue?vue&type=script&lang=js&"
export * from "./MapaSetorizacao.vue?vue&type=script&lang=js&"
import style0 from "./MapaSetorizacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports